/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("lt", {
  Redo: "Gr\u0105\u017einti",
  Undo: "Atstatyti",
  Cut: "I\u0161kirpti",
  Copy: "Kopijuoti",
  Paste: "\u012ed\u0117ti",
  "Select all": "Pa\u017eym\u0117ti visk\u0105",
  "New document": "Naujas dokumentas",
  Ok: "Gerai",
  Cancel: "Atsisakyti",
  "Visual aids": "Vaizdin\u0117s priemon\u0117s",
  Bold: "Pary\u0161kintas",
  Italic: "Kursyvinis",
  Underline: "Pabrauktas",
  Strikethrough: "Perbrauktas",
  Superscript: "Vir\u0161utinis indeksas",
  Subscript: "Apatinis indeksas",
  "Clear formatting": "Naikinti formatavim\u0105",
  "Align left": "Lygiuoti kair\u0117je",
  "Align center": "Centruoti",
  "Align right": "Lygiuoti de\u0161in\u0117je",
  Justify: "I\u0161d\u0117styti per vis\u0105 plot\u012f",
  "Bullet list": "\u017denklinimo s\u0105ra\u0161as",
  "Numbered list": "Skaitmeninis s\u0105ra\u0161as",
  "Decrease indent": "Ma\u017einti \u012ftrauk\u0105",
  "Increase indent": "Didinti \u012ftrauk\u0105",
  Close: "U\u017edaryti",
  Formats: "Formatai",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Nar\u0161ykl\u0117s nustatymai neleid\u017eia redaktoriui tiesiogiai pasiekti laikinosios atminties. Pra\u0161ome naudoti klaviat\u016bros klavi\u0161us Ctrl+X/C/V.",
  Headers: "Antra\u0161t\u0117s",
  "Header 1": "Antra\u0161t\u0117 1",
  "Header 2": "Antra\u0161t\u0117 2",
  "Header 3": "Antra\u0161t\u0117 3",
  "Header 4": "Antra\u0161t\u0117 4",
  "Header 5": "Antra\u0161t\u0117 5",
  "Header 6": "Antra\u0161t\u0117 6",
  Headings: "Antra\u0161t\u0117s",
  "Heading 1": "Antra\u0161t\u0117 1",
  "Heading 2": "Antra\u0161t\u0117 2",
  "Heading 3": "Antra\u0161t\u0117 3",
  "Heading 4": "Antra\u0161t\u0117 4",
  "Heading 5": "Antra\u0161t\u0117 5",
  "Heading 6": "Antra\u0161t\u0117 6",
  Preformatted: "Suformuotas i\u0161 anksto",
  Div: "Div",
  Pre: "Pre",
  Code: "Kodas",
  Paragraph: "Paragrafas",
  Blockquote: "Citata",
  Inline: "Inline",
  Blocks: "Blokai",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Dabar \u012fterpiama paprastojo teksto re\u017eimu. Kol \u0161i parinktis \u012fjungta, turinys bus \u012fterptas kaip paprastas tekstas.",
  Fonts: "\u0160riftai",
  "Font Sizes": "\u0160rifto dyd\u017eiai",
  Class: "Klas\u0117",
  "Browse for an image": "Ie\u0161koti paveiksl\u0117lio",
  OR: "ARBA",
  "Drop an image here": "Tempkite paveiksl\u0117l\u012f \u010dia",
  Upload: "\u012ekelti",
  Block: "Blokas",
  Align: "Lygiavimas",
  Default: "Pagrindinis",
  Circle: "Apskritimas",
  Disc: "Diskas",
  Square: "Kvadratas",
  "Lower Alpha": "Ma\u017eosios raid\u0117s",
  "Lower Greek": "Ma\u017eosios graik\u0173",
  "Lower Roman": "Ma\u017eosios rom\u0117n\u0173",
  "Upper Alpha": "Did\u017eiosios raid\u0117s",
  "Upper Roman": "Did\u017eiosios rom\u0117n\u0173",
  "Anchor...": "Nuoroda...",
  Name: "Pavadinimas",
  Id: "ID",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "ID turi prasid\u0117ti raide, po kurios gali b\u016bti raid\u0117s, skai\u010diai, br\u016bk\u0161niai, ta\u0161kai, kabliata\u0161kiai ar apatiniai pabraukimai.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Turite nei\u0161saugot\u0173 pakeitim\u0173! Ar tikrai norite i\u0161eiti?",
  "Restore last draft": "Atstatyti paskutin\u012f projekt\u0105",
  "Special character...": "Specialieji simboliai...",
  "Source code": "Pirminis \u0161altinis",
  "Insert/Edit code sample": "Prid\u0117ti / keisti kodo pavyzd\u012f",
  Language: "Kalba",
  "Code sample...": "Kodo pavyzdys...",
  "Color Picker": "Spalvos parinkimas",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "I\u0161 kair\u0117s \u012f de\u0161in\u0119",
  "Right to left": "I\u0161 de\u0161in\u0117s \u012f kair\u0119",
  "Emoticons...": "Jaustukai...",
  "Metadata and Document Properties":
    "Meta duomenys ir dokumento ypatyb\u0117s",
  Title: "Pavadinimas",
  Keywords: "\u017dymos",
  Description: "Apra\u0161as",
  Robots: "Robotai",
  Author: "Autorius",
  Encoding: "Kodavimas",
  Fullscreen: "Visas ekranas",
  Action: "Veiksmas",
  Shortcut: "Nuoroda",
  Help: "Pagalba",
  Address: "Adresas",
  "Focus to menubar": "Fokusuoti \u012f meniu",
  "Focus to toolbar": "Fokusuoti \u012f \u012franki\u0173 juost\u0105",
  "Focus to element path": "Fokusuoti \u012f elemento keli\u0105",
  "Focus to contextual toolbar":
    "Fokusuoti \u012f kontekstin\u012f \u012franki\u0173 juost\u0105",
  "Insert link (if link plugin activated)":
    "Prid\u0117ti nuorod\u0105 (jei link priedas aktyvuotas)",
  "Save (if save plugin activated)":
    "I\u0161saugoti (jei save priedas aktyvuotas)",
  "Find (if searchreplace plugin activated)":
    "Ie\u0161koti (jei searchreplace priedas aktyvuotas)",
  "Plugins installed ({0}):": "\u012ediegti priedai ({0}):",
  "Premium plugins:": "Mokami priedai:",
  "Learn more...": "Su\u017einoti daugiau...",
  "You are using {0}": "Naudojate {0}",
  Plugins: "Priedai",
  "Handy Shortcuts": "Patogios nuorodos",
  "Horizontal line": "Horizontali linija",
  "Insert/edit image": "\u012eterpti|Tvarkyti paveiksl\u0117l\u012f",
  "Image description": "Paveiksl\u0117lio apra\u0161as",
  Source: "Pirmin\u0117 nuoroda",
  Dimensions: "Matmenys",
  "Constrain proportions": "Laikytis proporcij\u0173",
  General: "Bendra",
  Advanced: "I\u0161pl\u0117stas",
  Style: "Stilius",
  "Vertical space": "Vertikalus tarpas",
  "Horizontal space": "Horizontalus tarpas",
  Border: "R\u0117melis",
  "Insert image": "\u012eterpti paveiksl\u0117l\u012f",
  "Image...": "Paveiksl\u0117lis...",
  "Image list": "Paveiksl\u0117li\u0173 s\u0105ra\u0161as",
  "Rotate counterclockwise": "Pasukti prie\u0161 laikrod\u017eio rodykl\u0119",
  "Rotate clockwise": "Pasukti pagal laikrod\u017eio rodykl\u0119",
  "Flip vertically": "Apversti vertikaliai",
  "Flip horizontally": "Apversti horizontaliai",
  "Edit image": "Redaguoti paveiksl\u0117l\u012f",
  "Image options": "Paveiksl\u0117lio nustatymai",
  "Zoom in": "Priartinti",
  "Zoom out": "Atitolinti",
  Crop: "Atkarpyti",
  Resize: "Keisti dyd\u012f",
  Orientation: "Pasukimas",
  Brightness: "\u0160viesumas",
  Sharpen: "Ry\u0161kumas",
  Contrast: "Kontrastas",
  "Color levels": "Spalv\u0173 lygiai",
  Gamma: "Gama",
  Invert: "Prie\u0161ingos spalvos",
  Apply: "Taikyti",
  Back: "Atgal",
  "Insert date/time": "\u012eterpti dat\u0105/laik\u0105",
  "Date/time": "Data / laikas",
  "Insert/Edit Link": "Prid\u0117ti/Keisti nuorod\u0105",
  "Insert/edit link": "\u012eterpti/taisyti nuorod\u0105",
  "Text to display": "Rodomas tekstas",
  Url: "Nuoroda",
  "Open link in...": "Nuorod\u0105 atverti...",
  "Current window": "Dabartiniame lange",
  None: "Nieko",
  "New window": "Naujas langas",
  "Remove link": "\u0160alinti nuorod\u0105",
  Anchors: "\u017dym\u0117",
  "Link...": "Nuoroda...",
  "Paste or type a link":
    "\u012eklijuokite arba \u012fra\u0161ykite nuorod\u0105",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "Atrodo, kad \u012fvesta nuoroda yra elektroninio pa\u0161to adresas. Ar norite prie\u0161 j\u012f \u012fvesti reikalaujam\u0105 \u201emailto:\u201c?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "Atrodo, kad \u012fved\u0117te nuotolin\u0119 nuorod\u0105. Ar norite prie\u0161 j\u0105 \u012fvesti reikalaujam\u0105 \u201ehttp://\u201c?",
  "Link list": "Nuorod\u0173 s\u0105ra\u0161as",
  "Insert video": "\u012eterpti video",
  "Insert/edit video": "\u012eterpti/tvarkyti video",
  "Insert/edit media": "Prid\u0117ti / keisti medij\u0105",
  "Alternative source": "Alternatyvus \u0161altinis",
  "Alternative source URL": "Alternatyvus \u0161altinio URL adresas",
  "Media poster (Image URL)":
    "medijos skelbiklis (paveiksl\u0117lio URL adresas)",
  "Paste your embed code below:": "\u012eterpkite kod\u0105 \u017eemiau:",
  Embed: "\u012eterpti",
  "Media...": "Medija...",
  "Nonbreaking space": "Nepertraukiamos vietos",
  "Page break": "Puslapio skirtukas",
  "Paste as text": "\u012eklijuoti kaip tekst\u0105",
  Preview: "Per\u017ei\u016bra",
  "Print...": "Spausdinti...",
  Save: "I\u0161saugoti",
  Find: "Ie\u0161koti",
  "Replace with": "Kuo pakeisti",
  Replace: "Pakeisti",
  "Replace all": "Pakeisti visk\u0105",
  Previous: "Ankstesnis",
  Next: "Sekantis",
  "Find and replace...": "Ie\u0161koti ir pakeisti...",
  "Could not find the specified string.":
    "Nepavyko rasti nurodytos eilut\u0117s.",
  "Match case": "Atitinkamus",
  "Find whole words only": "Ie\u0161koti tik vis\u0105 \u017eod\u012f",
  "Spell check": "Klaid\u0173 tikrinimas",
  Ignore: "Ignoruoti",
  "Ignore all": "Ignoruoti visk\u0105",
  Finish: "Baigti",
  "Add to Dictionary": "Prid\u0117ti \u012f \u017dodyn\u0105",
  "Insert table": "\u012eterpti lentel\u0119",
  "Table properties": "Lentel\u0117s savyb\u0117s",
  "Delete table": "\u0160alinti lentel\u0119",
  Cell: "Langeliai",
  Row: "Eilut\u0117s",
  Column: "Stulpelis",
  "Cell properties": "Langelio savyb\u0117s",
  "Merge cells": "Sujungti langelius",
  "Split cell": "Skaidyti langelius",
  "Insert row before": "\u012eterpti eilut\u0119 prie\u0161",
  "Insert row after": "\u012eterpti eilut\u0119 po",
  "Delete row": "Naikinti eilut\u0119",
  "Row properties": "Eilut\u0117s savyb\u0117s",
  "Cut row": "I\u0161kirpti eilut\u0119",
  "Copy row": "Kopijuoti eilut\u0119",
  "Paste row before": "\u012ed\u0117ti eilut\u0119 prie\u0161",
  "Paste row after": "\u012ed\u0117ti eilut\u0119 po",
  "Insert column before": "\u012eterpti stulpel\u012f prie\u0161",
  "Insert column after": "\u012eterpti stulpel\u012f po",
  "Delete column": "Naikinti stulpel\u012f",
  Cols: "Stulpeliai",
  Rows: "Eilut\u0117s",
  Width: "Plotis",
  Height: "Auk\u0161tis",
  "Cell spacing": "Tarpas tarp langeli\u0173",
  "Cell padding": "Tarpas nuo langelio iki teksto",
  "Show caption": "Rodyti antra\u0161t\u0119",
  Left: "Kair\u0117",
  Center: "Centras",
  Right: "De\u0161in\u0117",
  "Cell type": "Langelio tipas",
  Scope: "Strukt\u016bra",
  Alignment: "Lygiavimas",
  "H Align": "H Lygiavimas",
  "V Align": "V Lygiavimas",
  Top: "Vir\u0161uje",
  Middle: "Viduryje",
  Bottom: "Apa\u010dioje",
  "Header cell": "Antra\u0161t\u0117s langelis",
  "Row group": "Eilu\u010di\u0173 grup\u0117",
  "Column group": "Stulpeli\u0173 grup\u0117",
  "Row type": "Eilu\u010di\u0173 tipas",
  Header: "Antra\u0161t\u0117",
  Body: "Turinys",
  Footer: "Apa\u010dia",
  "Border color": "R\u0117melio spalva",
  "Insert template...": "Prid\u0117ti \u0161ablon\u0105...",
  Templates: "\u0160ablonai",
  Template: "\u0160ablonas",
  "Text color": "Teksto spalva",
  "Background color": "Fono spalva",
  "Custom...": "Pasirinktinas...",
  "Custom color": "Pasirinktina spalva",
  "No color": "Jokios spalvos",
  "Remove color": "Pa\u0161alinti spalv\u0105",
  "Table of Contents": "Turinys",
  "Show blocks": "Rodyti blokus",
  "Show invisible characters": "Rodyti nematomus simbolius",
  "Word count": "\u017dod\u017ei\u0173 kiekis",
  Count: "Skai\u010dius",
  Document: "Dokumentas",
  Selection: "Pasirinkimas",
  Words: "\u017dod\u017ei\u0173",
  "Words: {0}": "\u017dod\u017eiai: {0}",
  "{0} words": "{0} \u017eod\u017eiai",
  File: "Failas",
  Edit: "Redaguoti",
  Insert: "\u012eterpti",
  View: "Per\u017ei\u016bra",
  Format: "Formatas",
  Table: "Lentel\u0117",
  Tools: "\u012erankiai",
  "Powered by {0}": "Sukurta {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Suformatuoto teksto laukas. D\u0117l meniu spauskite ALT-F9. U\u017eduo\u010di\u0173 juostos \u012fjungimui spauskite ALT-F10. Pagalbai - spauskite ALT-0.",
  "Image title": "Paveiksl\u0117lio pavadinimas",
  "Border width": "Kra\u0161tin\u0117s plotis",
  "Border style": "Kra\u0161tin\u0117s stilius",
  Error: "Klaida",
  Warn: "\u012esp\u0117ti",
  Valid: "Tinkamas",
  "To open the popup, press Shift+Enter":
    "Spustel\u0117j\u0119 Shift+Enter atversite i\u0161kylant\u012f lang\u0105",
  "Rich Text Area. Press ALT-0 for help.":
    "Rai\u0161kiojo teksto vieta. Spustel\u0117j\u0119 Alt-0 gausite pagalbos.",
  "System Font": "Sisteminiai \u0161riftai",
  "Failed to upload image: {0}": "Paveiksl\u0117lio \u012fkelti nepavyko: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Priedo \u012fkelti nepavyko: {0} i\u0161 adreso {1}",
  "Failed to load plugin url: {0}": "Priedo adreso \u012fkelti nepavyko: {0}",
  "Failed to initialize plugin: {0}": "Priedo inicijuoti nepavyko: {0}",
  example: "pavyzdys",
  Search: "Ie\u0161koti",
  All: "Visi",
  Currency: "Valiuta",
  Text: "Tekstas",
  Quotations: "Citata",
  Mathematical: "Matematinis",
  "Extended Latin": "Lotyn\u0173 i\u0161pl\u0117stin\u0117",
  Symbols: "Simboliai",
  Arrows: "Rodykl\u0117s",
  "User Defined": "Vartotojo apibr\u0117\u017eta",
  "dollar sign": "dolerio \u017eenklas",
  "currency sign": "valiutos \u017eenklas",
  "euro-currency sign": "euro \u017eenklas",
  "colon sign": "dvita\u0161kio \u017eenklas",
  "cruzeiro sign": "kruzeiro \u017eenklas",
  "french franc sign": "Pranc\u016bz\u0173 franko \u017eenklas",
  "lira sign": "lyros \u017eenklas",
  "mill sign": "milo simbolis",
  "naira sign": "nairos simbolis",
  "peseta sign": "peseto \u017eenklas",
  "rupee sign": "rupijos \u017eenklas",
  "won sign": "vono \u017eenklas",
  "new sheqel sign": "naujojo \u0161ekelio \u017eenklas",
  "dong sign": "dongo \u017eenklas",
  "kip sign": "kipo \u017eenklas",
  "tugrik sign": "tugriko \u017eenklas",
  "drachma sign": "drachmos \u017eenklas",
  "german penny symbol": "Vokietijos fenigo \u017eenklas",
  "peso sign": "peso \u017eenklas",
  "guarani sign": "gvaranio \u017eenklas",
  "austral sign": "australo \u017eenklas",
  "hryvnia sign": "grivinos \u017eenklas",
  "cedi sign": "sed\u017eio \u017eenklas",
  "livre tournois sign": "toro svaro \u017eenklas",
  "spesmilo sign": "spesmilo \u017eenklas",
  "tenge sign": "teng\u0117s \u017eenklas",
  "indian rupee sign": "Indijos rupijos \u017eenklas",
  "turkish lira sign": "Turkijos lyros \u017eenklas",
  "nordic mark sign":
    "\u0161iaur\u0117s \u0161ali\u0173 mark\u0117s \u017eenklas",
  "manat sign": "manato \u017eenklas",
  "ruble sign": "rublio \u017eenklas",
  "yen character": "jienos simbolis",
  "yuan character": "juanio simbolis",
  "yuan character, in hong kong and taiwan":
    "juanio \u017eenklas, naudojamas Hongkonge ir Taivane",
  "yen/yuan character variant one": "jienos/juanio vieningas \u017eenklas",
  "Loading emoticons...": "\u012ekeliami jaustukai...",
  "Could not load emoticons": "Nepavyko \u012fkelti jaustuk\u0173",
  People: "\u017dmon\u0117s",
  "Animals and Nature": "Gyv\u016bnai ir gamta",
  "Food and Drink": "Maistas ir g\u0117rimai",
  Activity: "Veikla",
  "Travel and Places": "Kelion\u0117s ir vietos",
  Objects: "Objektai",
  Flags: "V\u0117liavos",
  Characters: "Simboli\u0173",
  "Characters (no spaces)": "Simboli\u0173 (be tarp\u0173)",
  "{0} characters": "{0} simboliai",
  "Error: Form submit field collision.":
    "Klaida: formos lauk\u0173 nesuderinamumas.",
  "Error: No form element found.": "Klaida: formos element\u0173 nerasta.",
  Update: "Naujinti",
  "Color swatch": "Spalv\u0173 pavyzd\u017eiai",
  Turquoise: "\u017dalsvai m\u0117lyna",
  Green: "\u017dalia",
  Blue: "M\u0117lyna",
  Purple: "Ro\u017ein\u0117",
  "Navy Blue": "Tamsiai m\u0117lyna",
  "Dark Turquoise": "Tamsiai \u017ealsvai m\u0117lyna",
  "Dark Green": "Tamsiai \u017ealia",
  "Medium Blue": "Vidutini\u0161kai m\u0117lyna",
  "Medium Purple": "Vidutini\u0161kai violetin\u0117",
  "Midnight Blue": "Vidurnak\u010dio m\u0117lyna",
  Yellow: "Geltona",
  Orange: "Oran\u017ein\u0117",
  Red: "Raudona",
  "Light Gray": "\u0160viesiai pilka",
  Gray: "Pilka",
  "Dark Yellow": "Tamsiai geltona",
  "Dark Orange": "Tamsiai oran\u017ein\u0117",
  "Dark Red": "Tamsiai raudona",
  "Medium Gray": "Vidutini\u0161kai pilka",
  "Dark Gray": "Tamsiai pilka",
  "Light Green": "\u0160viesiai \u017ealia",
  "Light Yellow": "\u0160viesiai geltona",
  "Light Red": "\u0160viesiai raudona",
  "Light Purple": "\u0160viesiai violetin\u0117",
  "Light Blue": "\u0160viesiai m\u0117lyna",
  "Dark Purple": "Tamsiai violetin\u0117",
  "Dark Blue": "Tamsiai m\u0117lyna",
  Black: "Juoda",
  White: "Balta",
  "Switch to or from fullscreen mode":
    "Perjungti i\u0161/\u012f viso ekrano rodym\u0105",
  "Open help dialog": "Atverti pagalbos lang\u0105",
  history: "praeitis",
  styles: "stiliai",
  formatting: "formatavimas",
  alignment: "lygiavimas",
  indentation: "\u012ftrauka",
  "permanent pen": "nuolatinis ra\u0161iklis",
  comments: "komentarai",
  "Format Painter": "Formato kopijavimo priemon\u0117",
  "Insert/edit iframe": "Prid\u0117ti / keisti iframe",
  Capitalization: "Did\u017eiosios raid\u0117s",
  lowercase: "ma\u017eosios raid\u0117s",
  UPPERCASE: "VISOS DID\u017dIOSIOS",
  "Title Case": "Pirmos Did\u017eiosios",
  "Permanent Pen Properties": "Nuolatinio ra\u0161iklio nustatymai",
  "Permanent pen properties...": "Nuolatinio ra\u0161iklio nustatymai...",
  Font: "\u0160riftas",
  Size: "Dydis",
  "More...": "Daugiau...",
  "Spellcheck Language": "Ra\u0161ybos tikrinimo kalba",
  "Select...": "Pasirinkti...",
  Preferences: "Nustatymai",
  Yes: "Taip",
  No: "Ne",
  "Keyboard Navigation": "Valdymas klaviat\u016bra",
  Version: "Versija",
  Anchor: "\u017dym\u0117",
  "Special character": "Specialus simbolis",
  "Code sample": "Kodo pavyzdys",
  Color: "Spalva",
  Emoticons: "Jaustukai",
  "Document properties": "Dokumento savyb\u0117s",
  Image: "Paveiksl\u0117lis",
  "Insert link": "\u012eterpti nuorod\u0105",
  Target: "Tikslin\u0117 nuoroda",
  Link: "Nuoroda",
  Poster: "Plakatas",
  Media: "Medija",
  Print: "Spausdinti",
  Prev: "Ankstesnis",
  "Find and replace": "Surasti ir pakeisti",
  "Whole words": "Visus \u017eod\u017eius",
  Spellcheck: "Ra\u0161ybos tikrinimas",
  Caption: "Antra\u0161t\u0117",
  "Insert template": "\u012eterpti \u0161ablon\u0105",
});
